module.exports = __webpack_public_path__ + "static/media/arrow.31694f3d.svg";